/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import {
    Avatar,
    Grid,
    Card,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Tooltip,
    Typography,
    IconButton,
    Menu,
    MenuItem,
    ListItemIcon,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import MDLoading from "components/MDLoading/MDLoading";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Loader from "components/custom/Loader";
import CustomMaterialTablePage from "../../components/custom/CustomMaterialTablePage";
import useApiRequest from "utils/Apirequest";
import { convertUTCtoDubai } from "utils/Constant";
import PopAddSupervisor from "./PopAddSupervisor";
import { Tag } from "antd";
import { capitalizeFirstLetterSafe } from "utils";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import Reset_pass_icon from "../../assets/cms-icons/resetPsw.png";
import Divider from "@mui/material/Divider";
import BlockIcon from "@mui/icons-material/Block";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

function Supervisor() {
    const apiRequest = useApiRequest();
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const { sidenavColor } = controller;
    const [supRows, setSupRows] = useState([]);
    const [supcolumns, setSupColumns] = useState([]);
    const navigate = useNavigate();


    const getValues3 = () => {
        return {
            first_name: "",
            last_name: "",
            email: "",
            phoneNumber: "",
            password: "",
            locationId: ""
        };
    };



    const [isDisabled2, setIsDisabled2] = useState(false);
    const [values3] = useState(getValues3);
    const [isAdminTableLoading, setIsAdminTableLoading] = useState(true);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const statusList = ["active", "inactive"];





    const [suppagination, setSupPagination] = useState({
        pageIndex: 0,
        pageSize: 20,
    });

    const [suppage, setSupPage] = useState(0);
    const [supsearchText, setSupSearchText] = useState("");
    const [supsorting, setSupSorting] = useState([
        {
            id: "createdAt",
            desc: true,
        },
    ]);
    const [suppageSize, setSupPageSize] = useState(20);
    const [suptotalRows, setSupTotalRows] = useState(0);
    const [supcolumnVisibility, setSupColumnVisibility] = useState({});
    const [supcolumnFilters, setSupColumnFilters] = useState([]);

    const [openDialog, setOpenDialog] = useState(false);
    const [editLoading] = useState(false);
    const [dialogEditData, setDialogEditData] = useState({
        user_id: null,
        name: "",
    });

    const [columnOrder, setColumnOrder] = useState([
        'status',
        'name',
        'email',
        'phoneNumber',
        'location',
        'city',
        'lastActiveAt',
        'createdAt'
    ]);

    const handleEdit = (rowData) => {
        navigate("/supervisor/edit", { state: rowData });
    };

    const ResetPassword = (row_data) => {
        navigate("/supervisor/reset-password", { state: row_data });
    };


    const handleSupSortingChange = (newSorting) => {
        setSupSorting(newSorting);
    };

    const handleSupSearchChange = (event) => {
        setSupSearchText(event);
        setSupPage(0);
    };



    useEffect(() => {
        setSupPage(suppagination.pageIndex);
        setSupPageSize(suppagination.pageSize);
    }, [suppagination]);



    const onCloseDialog = (e, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        setOpenDialog(false);
    };

    const onUpdate = async () => { };

    const updateSupervisorStatus = async (rowData, newStatus) => {
        try {
            await apiRequest(
                "patch",
                `/supervisor/status/${rowData?._id}`,
                { status: newStatus },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );

            // Update supervisors table live
            setSupRows((prev) =>
                prev.map((row) =>
                    row._id === rowData._id
                        ? { ...row, status: newStatus }
                        : row
                )
            );
        } catch (err) {
            console.error(err);
        }
    };

    const supColumn = [
        {
            id: "name",
            header: "Name",
            size: 200,
            muiTableHeadCellProps: { align: "center" },
            muiTableBodyCellProps: { align: "center" },
            accessorFn: (row) => `${row.firstName} ${row.lastName}`,
            align: "center",
        },
        {
            header: "Status",
            size: 200,
            muiTableHeadCellProps: { align: "center" },
            muiTableBodyCellProps: { align: "center" },
            filterVariant: "select",
            filterSelectOptions: statusList,
            accessorKey: "status",
            align: "center",
            Cell: ({ row }) => {
                const status = row.original.status;
                const statusColors = {
                    Active: "green",
                    inactive: "red",
                };

                const color = statusColors[status] || "red";

                return (
                    <MDBox
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        borderRadius="md"
                        style={{ flex: 1 }}
                    >
                        <Tag color={color}>{capitalizeFirstLetterSafe(status)}</Tag>
                    </MDBox>
                );
            },
        },
        {
            header: "Email",
            size: 200,
            muiTableHeadCellProps: { align: "center" },
            muiTableBodyCellProps: { align: "center" },
            accessorKey: "email",
            align: "center",
        },
        {
            header: "Phone",
            size: 200,
            muiTableHeadCellProps: { align: "center" },
            muiTableBodyCellProps: { align: "center" },
            accessorKey: "phoneNumber",
            align: "center",
        },
        {
            id: "location",
            header: "Location",
            size: 200,
            muiTableHeadCellProps: { align: "center" },
            muiTableBodyCellProps: { align: "center" },
            accessorFn: (row) => row.locationId?.locationName || "N/A",
            align: "center",
        },
        {
            id: "city",
            header: "City",
            size: 200,
            muiTableHeadCellProps: { align: "center" },
            muiTableBodyCellProps: { align: "center" },
            accessorFn: (row) => row.locationId?.city || "N/A",
            align: "center",
        },
        {
            header: "Last Active",
            size: 200,
            enableColumnFilter: false,
            muiTableHeadCellProps: { align: "center" },
            muiTableBodyCellProps: { align: "center" },
            accessorKey: "lastActiveAt",
            Cell: ({ cell }) =>
                cell.getValue()
                    ? convertUTCtoDubai(cell.getValue())
                    : "N/A",
            align: "center",
        },
        {
            header: "Created At",
            size: 200,
            enableColumnFilter: false,
            muiTableHeadCellProps: { align: "center" },
            muiTableBodyCellProps: { align: "center" },
            accessorKey: "createdAt",
            Cell: ({ cell }) =>
                cell.getValue()
                    ? convertUTCtoDubai(cell.getValue())
                    : "N/A",
            align: "center",
        },
        {
            header: "Action",
            accessorKey: "action",
            enableColumnFilter: false,
            muiTableHeadCellProps: {
                align: "center",
            },
            muiTableBodyCellProps: {
                align: "center",
            },
            size: 180,
            align: "center",

            Cell: ({ row }) => {
                const [anchorEl, setAnchorEl] = useState(null);
                const open = Boolean(anchorEl);

                const handleClick = (event) => setAnchorEl(event.currentTarget);
                const handleClose = () => setAnchorEl(null);

                const isActive = row.original.status?.toLowerCase() === "active";

                return (
                    <>
                        <IconButton onClick={handleClick}>
                            <MoreVertIcon />
                        </IconButton>

                        <Menu
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                        >
                            <MenuItem
                                onClick={() => {
                                    handleEdit(row.original);
                                    handleClose();
                                }}
                            >
                                <ListItemIcon>
                                    <EditIcon fontSize="small" />
                                </ListItemIcon>
                                <Typography variant="inherit">
                                    Edit Supervisor
                                </Typography>
                            </MenuItem>

                            <Divider />

                            <MenuItem
                                onClick={() => {
                                    ResetPassword(row.original);
                                    handleClose();
                                }}
                            >
                                <ListItemIcon
                                    sx={{
                                        "& img": {
                                            width: 18,
                                            height: 18,
                                            filter: "brightness(0) invert(0.6)",
                                        },
                                    }}
                                >
                                    <img src={Reset_pass_icon} alt="Reset Password" />
                                </ListItemIcon>
                                <Typography variant="inherit">
                                    Reset Password
                                </Typography>
                            </MenuItem>

                            <Divider />

                            <MenuItem
                                onClick={() => {
                                    updateSupervisorStatus(
                                        row.original,
                                        isActive ? "Inactive" : "Active"
                                    );
                                    handleClose();
                                }}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 28,
                                        color: isActive ? "#DC2626" : "#22C55E",
                                    }}
                                >
                                    {isActive ? (
                                        <BlockIcon fontSize="small" />
                                    ) : (
                                        <CheckCircleIcon fontSize="small" />
                                    )}
                                </ListItemIcon>
                                <Typography
                                    variant="inherit"
                                    sx={{ color: isActive ? "error.main" : "success.main" }}
                                >
                                    {isActive ? "Inactivate Supervisor" : "Activate Supervisor"}
                                </Typography>
                            </MenuItem>
                        </Menu>
                    </>
                );
            },
        },

    ];

    useEffect(() => {
        setSupColumns(supColumn);
    }, []);




    const fetchSupervisorData = async () => {
        const { data } =
            (await apiRequest(
                "get",
                `/supervisor/list?page=${suppage + 1}&limit=${suppageSize}`,
                null,
                {},
            )) || {};

        if (data?.success || data?.status) {
            console.log("Data", data);
            setSupRows(data?.data?.supervisors);
            setSupTotalRows(data?.data?.pagination?.totalCount);
            setIsAdminTableLoading(false);
        }
    };

    useEffect(() => {

        fetchSupervisorData();

    }, [suppage, suppageSize]);



    return (
        <DashboardLayout>

            <PopAddSupervisor
                isDialog={isDisabled2}
                onClose={setIsDisabled2}
                value={values3}
            />
            <DashboardNavbar />
            <MDBox pt={3} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={1}
                                px={2}
                                variant="gradient"
                                bgColor={sidenavColor}
                                borderRadius="lg"
                                coloredShadow={sidenavColor}
                            >
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <MDTypography
                                        variant="h6"
                                        color="white"
                                        style={{ width: "50%" }}
                                    >
                                        Supervisors
                                    </MDTypography>




                                    <MDBox
                                        className="admin_btnsHeaderCont"
                                        style={{
                                            display: "flex",

                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <MDButton
                                            onClick={() => setIsDisabled2(!isDisabled2)}
                                            variant="outlined"
                                            color="white"
                                        >
                                            Add Supervisor
                                        </MDButton>

                                    </MDBox>
                                </Grid>
                            </MDBox>
                            {isAdminTableLoading ? (
                                <Loader />
                            ) : (
                                <CustomMaterialTablePage
                                    columns={supcolumns}
                                    data={supRows}
                                    darkMode={darkMode}
                                    manualPagination={true}
                                    manualFiltering={false}
                                    rowCount={suptotalRows}
                                    paginationChange={(newPage) => setSupPagination(newPage)}
                                    soringChange={handleSupSortingChange}
                                    page={suppage}
                                    pagesize={suppageSize}
                                    paginataion={suppagination}
                                    sorting={supsorting}
                                    searchText={supsearchText}
                                    searchChange={handleSupSearchChange}
                                    onColumnFiltersChange={setSupColumnFilters}
                                    onColumnVisibilityChange={setSupColumnVisibility}
                                    onColumnOrderChange={setColumnOrder}
                                    state={{
                                        pagination: suppagination,
                                        sorting: supsorting,
                                        columnFilters: supcolumnFilters,
                                        columnVisibility: supcolumnVisibility,
                                        columnOrder: columnOrder
                                    }}
                                    globalFilterDebounceMs={2000}
                                />
                            )}

                        </Card>
                    </Grid>
                </Grid>
            </MDBox>


            <MDLoading open={deleteLoading} />

            <Dialog fullWidth maxWidth="md" open={openDialog} onClose={onCloseDialog}>
                <DialogTitle sx={{ color: "#000" }}>Update Admin</DialogTitle>
                <DialogContent>
                    <MDInput
                        type="text"
                        label="Name"
                        value={dialogEditData.name}
                        name="name"
                        margin="dense"
                        fullWidth
                        onChange={(e) =>
                            setDialogEditData({ ...dialogEditData, name: e.target.value })
                        }
                    />
                </DialogContent>
                <DialogActions>
                    <MDButton
                        variant="outlined"
                        color="info"
                        onClick={onCloseDialog}
                        disabled={editLoading}
                    >
                        Close
                    </MDButton>
                    <MDButton
                        variant="gradient"
                        onClick={onUpdate}
                        style={{ backgroundColor: "darkgreen", color: "#fff" }}
                        disabled={editLoading}
                    >
                        Update
                    </MDButton>
                </DialogActions>
            </Dialog>
        </DashboardLayout>
    );
}

export default Supervisor;
